const MUTATION_TYPE = {
  clearTestContent: 'clearTestContent',
  setEditedTestId: 'setEditedTestId',
  setTestViewMode: 'setTestViewMode',
  setBackLink: 'setBackLink',
  setTest: 'setTest',
  setTestCreationMode: 'setTestCreationMode',
  setTestingMode: 'setTestingMode',
  setProgress: 'setProgress',
  updateSolvedTasks: 'updateSolvedTasks',
  setTestInTestModulePositions: 'setTestInTestModulePositions'
}

const ACTION_TYPE = {
  updateTestCreationMode: 'updateTestCreationMode',
  updateEditedTest: 'updateEditedTest',
  resetTestingModes: 'resetTestingModes',
  updateTestViewMode: 'updateTestViewMode',
  updateBackLink: 'updateBackLink',
  fetchTest: 'fetchTest',
  sendTestAnswer: 'sendTestAnswer'
}

const GETTER_TYPE = {
  getEditedTestId: 'getEditedTestId',
  isTestViewMode: 'isTestViewMode',
  getBackLink: 'getBackLink',
  getTest: 'getTest',
  isTestingMode: 'isTestingMode',
  getProgress: 'getProgress',
  getSolvedTasks: 'getSolvedTasks',
  isTestCreationMode: 'isTestCreationMode'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
